import { useEffect, useState } from "react";
import { X, Trash2, Pencil } from "lucide-react";
import { SPACE_TYPES } from "./eventosUtils";

export default function SpacesModal({ spaces, onNy, onEndre, onSlett, onLukk }) {
  const [form, setForm] = useState({ name: "", type: "breakout", capacity: 0 });
  const [redigerer, setRedigerer] = useState(null);
  const [jobber, setJobber] = useState(false);

  useEffect(() => {
    const esc = (e) => { if (e.key === "Escape") onLukk(); };
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onLukk]);

  const sett = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const avbryt = () => { setRedigerer(null); setForm({ name: "", type: "breakout", capacity: 0 }); };

  const lagre = async () => {
    if (!form.name.trim() || jobber) return;
    setJobber(true);
    try {
      const payload = { ...form, capacity: Number(form.capacity) || 0 };
      if (redigerer) await onEndre(redigerer, payload);
      else await onNy(payload);
      avbryt();
    } finally {
      setJobber(false);
    }
  };

  const typeLabel = Object.fromEntries(SPACE_TYPES.map((t) => [t.k, t.label]));

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-[10vh] px-4" data-testid="spaces-modal">
      <div className="sak-backdrop absolute inset-0 bg-black/25" onClick={onLukk} />
      <div className="sak-modal relative w-full max-w-[520px] bg-white rounded-2xl shadow-2xl border border-[#E7E4DB]">
        <div className="flex items-center justify-between px-5 pt-4 pb-2">
          <div>
            <h2 className="text-[15px] font-semibold text-neutral-900">Rom & arealer</h2>
            <p className="text-[11.5px] text-neutral-400 mt-0.5">Deles av program, experiences og produksjon.</p>
          </div>
          <button type="button" onClick={onLukk} className="text-neutral-400 hover:text-neutral-800 transition-colors" data-testid="spaces-lukk">
            <X size={16} />
          </button>
        </div>

        <div className="px-5 pb-3 max-h-[40vh] overflow-y-auto">
          {spaces.map((sp) => (
            <div key={sp.id} className="group flex items-center gap-3 py-2.5 border-t border-neutral-50 first:border-0" data-testid={`space-rad-${sp.id}`}>
              <div className="flex-1 min-w-0">
                <p className="text-[13px] font-medium text-neutral-900">{sp.name}</p>
                <p className="text-[11px] text-neutral-400">
                  {typeLabel[sp.type] || sp.type}{sp.capacity ? ` · ${sp.capacity} kapasitet` : ""}
                </p>
              </div>
              <button
                type="button"
                onClick={() => { setRedigerer(sp.id); setForm({ name: sp.name, type: sp.type, capacity: sp.capacity }); }}
                className="p-1.5 text-neutral-300 hover:text-neutral-800 opacity-0 group-hover:opacity-100 transition-all"
              >
                <Pencil size={13} />
              </button>
              <button
                type="button"
                onClick={() => onSlett(sp)}
                className="p-1.5 text-neutral-300 hover:text-red-600 opacity-0 group-hover:opacity-100 transition-all"
                data-testid={`space-slett-${sp.id}`}
              >
                <Trash2 size={13} />
              </button>
            </div>
          ))}
        </div>

        <div className="px-5 py-4 border-t border-neutral-100 bg-neutral-50/50 rounded-b-2xl">
          <p className="text-[10.5px] font-semibold uppercase tracking-wider text-neutral-400 mb-2">
            {redigerer ? "Rediger rom" : "Nytt rom"}
          </p>
          <div className="grid grid-cols-3 gap-2">
            <input
              value={form.name}
              onChange={(e) => sett("name", e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") lagre(); }}
              placeholder="Navn *"
              className="adm-input col-span-3"
              data-testid="space-navn-input"
            />
            <select value={form.type} onChange={(e) => sett("type", e.target.value)} className="adm-input col-span-2">
              {SPACE_TYPES.map((t) => (
                <option key={t.k} value={t.k}>{t.label}</option>
              ))}
            </select>
            <input
              type="number"
              value={form.capacity}
              onChange={(e) => sett("capacity", e.target.value)}
              placeholder="Kapasitet"
              className="adm-input"
            />
          </div>
          <div className="flex items-center gap-2 mt-3">
            <button type="button" onClick={lagre} disabled={!form.name.trim() || jobber} className="adm-btn adm-btn-sm" data-testid="space-lagre">
              {jobber ? "Lagrer …" : redigerer ? "Lagre endringer" : "Legg til"}
            </button>
            {redigerer && (
              <button type="button" onClick={avbryt} className="text-[12px] text-neutral-500 px-2 hover:text-neutral-800 transition-colors">Avbryt</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
